<!-- <ng-progress color="red" [thick]="true" [showSpinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'"></ng-progress> -->
<div class="page-contents">
    <div class="subBlockContainer" id='levelOne'>
        <div class="breadcrumbWrapper">
            <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="subBlockContent">
            <child-header [title]="title" (closeEvent)="navigateTo('/home')" ></child-header>
            <div #ParentWrapper class="child-body">
                <div class="item-title-wrapper">
                        <!-- <div class="title blade-title-font">
                            {{title}}
                        </div>
                        <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/home']">close</i> -->
                        
                        <div class="page-title-description">
                            <div class="page-title-description" *ngIf="isAU">
								<!-- Keep up to date with all of the events we’re running around Australia all in one convenient place. We’re committed to training, enabling and celebrating with you, our valued partners. Check out what’s happening near you and register to attend. We look forward to seeing you at our next event!	 -->
                                We’ve built dedicated brand websites where you can learn more about how Dicker Data works with particular vendors. Check out the microsites below to discover why Dicker Data is the leading Australian distributor for the world’s leading technology companies.
							</div>
							<div class="page-title-description" *ngIf="!isAU">
								<!-- Keep up to date with all of the events we’re running around New Zealand all in one convenient place. We’re committed to training, enabling and celebrating with you, our valued partners. Check out what’s happening near you and register to attend. We look forward to seeing you at our next event!	 -->
                                We’ve built dedicated brand websites where you can learn more about how Dicker Data works with particular vendors. Check out the microsites below to discover why Dicker Data is the leading New Zealand distributor for the world’s leading technology companies.
							</div>
                        </div>

                        <div class="top-divider"></div>
                        <div class="topspot-header">Featured Microsites</div>
                        <div class="topspot-content" *ngIf="micrositeList?.length > 0">
                            <div class="flip-featured" *ngFor="let promotion of featuredMicrosites">
                                <div class="flip-featured-inner">
                                    <a [href]="promotion?.promotionLink">
                                        <div class="flip-featured-front">
                                            <img class="b-radius-x5"
                                                src="https://marketingdd.blob.core.windows.net/marketing/{{promotion.cloudFileName}}"
                                                onError="this.src='https://portal.dickerdata.com.au/resourcefiles/DickerData_Logo_BlackRed.png';"
                                                target="_blank" alt="" />
                                        </div>
                                    </a>
                                    <div class="flip-featured-back">
                                        <div class="flip-title">{{promotion.title}}</div>
                                        <div class="flip-link">
                                            <button (click)="onNavigate(promotion.id, promotion?.promotionLink)"
                                                class="button button-red button-mid margin-b-x10"
                                                target="_blank">Visit Microsite</button><br>
                                        </div>
                                    </div>
                                </div>
                        </div>

                        <div class="font-x10" *ngIf="micrositeList?.length < 1">No featured microsites to show.</div>
                    </div>
                    
                </div>
                <div class="mTable-header">
                    <div class="row filter-wrapper">
                        <div class="col-md-3">
                            <div class="searchInputGroup">
                                <div class="searchIcon">
                                    <img src="../images/new_ui/filter.png">
                                </div>
                                <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                                    onblur="this.placeholder='Filter'" [(ngModel)]="searchField"
                                    (ngModelChange)="filterMicrositeList()">
                            </div>
                        </div>

                        <div class="col-md-7 select-padding">
                            <mat-form-field class="select-wrapper">
                                <mat-select placeholder="View all" multiple [(ngModel)]="selectedBrands"
                                    #brandSelect="ngModel" (selectionChange)="updateBrandList($event)">
                                    <mat-select-trigger>
                                        {{brandSelect.model ? brandSelect.model[0] : ''}}
                                        <span *ngIf="brandSelect.value?.length > 1">
                                            (+{{brandSelect.model.length - 1}} {{brandSelect.model?.length === 2 ? 'other'
                                            :
                                            'others'}})
                                        </span>
                                    </mat-select-trigger>

                                    <mat-option *ngFor="let item of promotionsBrands | UniqueFilterPipe: 'brand'"
                                        [value]="item">
                                        {{item}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-1 clearFilterButton align-center" (click)="clearFilters()">
                            Clear filter
                        </div>
                    </div>
                    <div class="top-divider"></div>
                </div>
                <div class="inner-subBlock-wrapper">
                    
                    <div class="mTable">
                        <div *ngIf="selectedMicrositeList?.length > 0">
                            <table class="white external-table">
                                <tr class="external-row" *ngFor="let promotion of selectedMicrositeList">
                                    <td><img class="external-img"
                                            src="https://marketingdd.blob.core.windows.net/marketing/{{promotion.cloudFileName}}"
                                            onError="this.src='../images/new_ui/select-file.png';" alt="" target="_blank" />
                                    </td>
                                    <td>
                                        <div class="brand">
                                            {{promotion.brand}}
                                        </div>
                                        <div class="title">
                                            {{promotion.title}}
                                        </div>
                                        <div class="description">
                                            {{promotion.description}}
                                        </div>
                                    </td>
                                    <td class="align-center">
                                        <a class="button button-red button-mid font-x10"
                                        (click)="onNavigate(promotion.id, promotion?.promotionLink)"
                                        target="_blank">
                                            <div class="margin-t-x4 visitButton">Visit Microsite</div>
                                        </a>
                                        <br>
                                    </td>
                                    <div class="top-divider"></div>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="font-x10" *ngIf="selectedMicrositeList?.length < 1">No microsites to show.</div>
                </div>
            </div>
            <loading-screen *ngIf="!loadContent" [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)">
            </loading-screen>
        </div>
    </div>
</div>